import React from 'react'
import { View, ViewStyle } from 'react-native'

interface DividerProps {
  split?: React.ReactNode
  color?: string
  style?: ViewStyle
}

export const Divider = (props: DividerProps) => {
  const { style, split, color = '#000000' } = props
  const dividerStyle = { ...DIVIDER, backgroundColor: color }
  return (
    <View style={{ ...ROW, ...style }}>
      {split ? (
        <>
          <View style={dividerStyle} />
          {split}
          <View style={dividerStyle} />
        </>
      ) : (
        <View style={dividerStyle} />
      )}
    </View>
  )
}

const ROW: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  width: '100%',
}
const DIVIDER: ViewStyle = { height: 1, flex: 1 }
